<template>
  <div class="content content6">
    <div class="tab clearfix">
        <span class="title fl">#<em>联系我们</em></span>
        <ul class="nav fr">
            <li v-for="(item, index) in tabList" :key="index" @click="clickEvent(index)">
                {{item}}
                <span class="active" v-show="isActive == index"></span>
            </li>
        </ul>
    </div>
    <div class="tab-content clearfix">
        <div class="content-left fl">
            <ul v-for="(items, index) in tabContentList[isActive]" :key="index">
                <li class="clearfix">
                    <img :src="items.icon" alt="" class="fl">
                    <span class="minWidth fl">
                        <em>{{items.tit}}</em>
                        <span class="font-bold">{{items.addr}}</span>
                    </span>
                </li>
            </ul>
        </div>
        <div class="content-right fr">
          <div class="bm-view">
            <img :src="mapList[isActive].src" :alt="mapList[isActive].alt">
            <!--<map-container id-name="amap" :center="mapList[isActive].center" label="亚商资本"></map-container>-->
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import iconAddr from './icon_add.png'
import iconZipcode from './icon_zipcode.png'
import iconPhone from './icon_phone.png'
import iconFax from './icon_fax.png'
import iconEmail from './icon_email.png'
import map1 from './map1.png'
import map2 from './map2.png'
// import MapContainer from '../common/map-container'

export default {
  data () {
    return{
      isActive: 0,
      tabList: ['上海', '深圳'],
      tabContentList: [
          [
            {
                icon: iconAddr,
                tit: '地址',
                addr: '中国上海市长宁区延安西路2558号1号楼'
            },
            {
                icon: iconZipcode,
                tit: '邮编',
                addr: '201103'
            },
            {
                icon: iconPhone,
                tit: '电话',
                addr: '(+86) 021-62959001'
            },
            {
                icon: iconFax,
                tit: '传真',
                addr: '(+86) 021-62958055'
            },
            {
                icon: iconEmail,
                tit: '邮箱',
                addr: 'zp@abccapital.cn'
            }
          ],
          [
            {
                icon: iconAddr,
                tit: '地址',
                addr: '深圳市南山区科苑中路科兴科学园B座1单元1101B'
            },
            {
                icon: iconZipcode,
                tit: '邮编',
                addr: '518000'
            },
            {
                icon: iconPhone,
                tit: '电话',
                addr: '(+86) 0755-23910785'
            },
            {
                icon: iconFax,
                tit: '传真',
                addr: '(+86) 0755-23910785'
            },
            {
                icon: iconEmail,
                tit: '邮箱',
                addr: 'zp@abccapital.cn'
            }
          ]
      ],
      mapList: [
        {
          city: '上海',
          center: [121.397155, 31.198411],
          src: map1,
          alt: '亚商资本'
        },
        {
          city: '深圳',
          center: [113.943981, 22.549438],
          src: map2,
          alt: '亚商资本(深圳)'
        }
      ]
    }
  },
  methods: {
    clickEvent: function(index){
      this.isActive = index;
    }
  }
}
</script>

<style scoped>
.content6{
    margin-bottom: 70px;
    min-width: 1200px;
    padding-top: 200px;
}
.content6 .tab{
    padding: 0 120px 0px 174px;
    margin-bottom: 48px;
 }
 .content6 .title{
    font-size: 24px;
    color: #c70016;
    font-weight: 600;
 }
  .content6 .title em{
      font-style: normal;
      font-weight: 600;
    color: #333367;
  }
.content6 .nav li{
    display: inline-block;
    width: 90px;
    height: 42px;
    line-height: 42px;
    text-align: center;
    color: #1e1e1e;
    font-size: 18px;
    position: relative;
    cursor: pointer;
}
.content6 .tab .active{
    width: 32px;
    height: 4px;
    background: #c8001c;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-16px);
    -moz-transform: translateX(-16px);
}
.tab-content .content-left{
    width: 35%;
    padding: 70px 0 0 48px;
    background: url('./bg.png') no-repeat 0 0;
}
.content-left .minWidth{
    width: 430px;
    /* width: 455px; */
}
.tab-content .content-right{
    width: 55%;
    height: 608px;
    padding-top: 56px;
    box-sizing: border-box;
}
.tab-content ul li{
    width: 514px;
    color: #313565;
    margin-bottom: 78px;
}
.tab-content ul em{
    font-style: normal;
    display: block;
    margin-bottom: 5px;
}
.tab-content ul img{
    margin-right: 28px;
}
.tab-content ul .font-bold{
    font-weight: 600;
    font-size: 20px;
}
.bm-view{
    width: 100%;
    height: 100%;
    border: 3px solid #464775;
}
</style>



// WEBPACK FOOTER //
// src/components/contactUs/contactUs.vue